import { FC } from "react";
import { useNavigate } from "react-router";
import { EmailGateForm } from "../../registration/email-gate/EmailGateForm";
import { RegistrationFormResource } from "../../shared/types/registrationForm";

interface Props {
	registrationForm: RegistrationFormResource;
}

export const EmailGatePreviewPage: FC<Props> = ({ registrationForm }) => {
	const navigate = useNavigate();

	return <EmailGateForm registrationForm={registrationForm} onSubmit={async () => navigate("../landing-page")} />;
};
